import React, { useEffect, useState } from "react";
import styles from "./comment.module.css";
import axios from "axios";

const data = [
  {
    comment_able: true,
    drName: "دکتر افسانه مهرنامی",
    date: "چهارشنبه ۳۰ شهریور ۱۴۰۱",
    name: "پیمان وثوق",
    photo: "https://mystatic.ir/v1/doctor/profile_photo/113444/normalSquare",
    speciality: "متخصص قلب و عروق ",
    url: "https://user.nobat.ir/turns?123141",
  },
];

const Comment = (props) => {
  const [commentData, setCommentData] = useState([]);

  useEffect(() => {
    loginAction();
    // setCommentData(data)
  }, []);

  const loginAction = async () => {
    const formData = new FormData();
    let config = {
      method: "post",
      url: window.server + "/patient/check/auth",
      data: formData,
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      let response = await axios(config);
      let res = response.data;
      setCommentData(res);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={styles.main}>
      {commentData.length > 0 && (
        <div className={styles.comment_box}>
          <span>
            {" "}
            {commentData[0].name} عزیز شما در تاریخ {commentData[0].date} توسط{" "}
            {commentData[0].drName} ویزیت شدید{" "}
          </span>
          <span> لطفا نظر خود را در خصوص این ویزیت ثبت نمایید </span>
          <a href={commentData[0].url} className={`${styles.follow_ok_box}`}>
            {<span> ثبت نظر </span>}
          </a>
        </div>
      )}
    </div>
  );
};

export default Comment;
